/* eslint-disable */
import { useCallback } from 'react';
import PropTypes from 'prop-types';
import api from '../../../api/req';

//  Все конечные точки, начинающиеся с auth, генерируются djoser.
// /auth/users/	Зарегистрировать нового пользователя
// /auth/users/me/	получить/обновить зарегистрированного пользователя
// /auth/jwt/create/	создать JWT, передав действующему пользователю в запросе post эту конечную точку
// /auth/jwt/refresh/	получить новый JWT по истечении времени жизни ранее сгенерированного

// /api/accounts/all-profiles/	получить все профили пользователей и создать новый
// /api/accounts/profile/id/	подробный вид профиля пользователя
//

const useAuth = () => {
  const clearSession = useCallback(
    (setAuth) => {
      window.localStorage.removeItem('refreshToken');
      setAuth({
        accessToken: null,
        refreshToken: null,
        currentUser: null,
      });
    },
    [],
  );

  const tryLogout = useCallback(
    (auth) => {
      api.get$('/api-auth/logout', () => ({ access: auth.accessToken })).then((r) => {
        if (r.ok) {
          clearSession();
        }
      });
    },
    [clearSession],
  );

  const tryRefresh = useCallback(
    async ({ auth, setAuth }) => {
      const refreshToken = auth.refreshToken || window.localStorage.getItem('refreshToken');
      if (refreshToken) {
        const r = await api.post$('/auth/jwt/refresh/', () => null, { refresh: refreshToken });
        if (r.ok) {
          const d = await r.json();
          window.localStorage.setItem('refreshToken', refreshToken);
          setAuth({
            ...auth,
            accessToken: d.access,
            refreshToken,
          });
          // console.log('d.access', d.access);
          return () => ({
            access: d.access,
          });
        }
      }
      tryLogout();
      return false;
    },
    [tryLogout],
  );

  const getAuth = useCallback(
    (auth) => ({
      access: auth.accessToken,
      onRefresh: tryRefresh,
    }),
    [tryRefresh],
  );

  const tryCurrentUser = useCallback(async ({ access, refresh, setAuth }) => {
    const r = await api.get$('/auth/users/me/', () => ({ access }));

    if (r.ok) {
      const d = await r.json();
      setAuth({
        currentUser: d,
        accessToken: access,
        refreshToken: refresh,
      });
      return true;
    }

    return false;
  }, []);

  const loginHandler = useCallback(async ({ login, pass, setAuth, setErrMsg }) => {
    const r = await api.post$('/auth/jwt/create/', () => null, { username: login, password: pass });
    if (r.ok) {
      const d = await r.json();
      const { access, refresh } = d;
      if (await tryCurrentUser({ access, refresh, setAuth })) {
        window.localStorage.setItem('refreshToken', refresh);
      }

      return true;
    } else {
      if (r.status === 401) {
          try {
              r.json().then(
                  (data)=> {
                      setErrMsg(data.detail);
                  });
            }
            catch {
              setErrMsg('Помилка авторізації');
          }
      }
    }
    }, [tryCurrentUser]);



    const sendEmail = useCallback(
    async (email, setShowMsg) => {
         api.post$('/auth/users/reset_password/', () => null, {email}).then((r) => {
             if (r.ok) {
                 setShowMsg('Лист було надіслано');
                 return true;
             }
             setShowMsg('Лист НЕ було надіслано!');
             return false;
         })
     },
    []
  );



  const resetPassHandler = useCallback(
      async (email, setShowMsg) => {
         const r = await api.post$('/api/user-auth/check-email/', () => null, {email});
             if (r.ok) {
                 await sendEmail(email, setShowMsg);
             } else {
                 if (r.status === 403) {
                     r.text().then((data) => {
                         setShowMsg(data);
                     });
                 } else {
                     setShowMsg(`${response.status} ${response.statusText}`)
                 }
             }
      }, []);



  const ativationNewPassHandler = useCallback(
    async ({
      uid,
      token,
      new_password,
      re_new_password,
      setShowMsg,
    }) => {
      const param = {
        uid,
        token,
        new_password,
        re_new_password,
      };

        api.post$('/auth/users/reset_password_confirm/', () => null, param).then((r) => {
        if (r.ok) {
          setShowMsg('Пароль було змінено');
          return true;
        }
            setShowMsg(`Пароль НЕ було змінено! Зверніться до адміністратора системи. Опис проблеми: - "${r.status}. ${r.statusText}"`);
        });
    },
    [],
  );



  return {
    tryLogout,
    tryRefresh,
    getAuth,
    loginHandler,
    resetPassHandler,
    ativationNewPassHandler,
  };
};

useAuth.propTypes = {
  auth: PropTypes.shape({
    // eslint-disable-next-line react/forbid-prop-types
    currentUser: PropTypes.object,
    accessToken: PropTypes.string,
    refreshToken: PropTypes.string,
  }),
  setAuth: PropTypes.func,
};

useAuth.defaultProps = {
  auth: {
    currentUser: null,
    accessToken: '',
    refreshToken: '',
  },
  setAuth: () => null,
};

export default useAuth;
